<template>
  <div class="tables-screen">
    <aside class="sidebar">
      <img src="@/assets/GR-logo.250.png" alt="Giverise Logo" class="logo" /> <!-- Replace text with image -->
      <ul class="nav-menu">
        <li @click="navigateTo('dashboard')" class="nav-item">Dashboard</li>
        <li @click="navigateTo('tables')" class="nav-item active">Tables</li>
        <li @click="navigateTo('invitees')" class="nav-item">Invitees</li>
        <li @click="navigateTo('donations')" class="nav-item">Donations</li>
        <li @click="logout" class="nav-item logout">Logout</li>
      </ul>
    </aside>
    
    <main class="main-content">
      <h1 class="main-title">Gala Dinner</h1>

      <!-- Toolbar with Shapes -->
      <div class="toolbar">
        <div class="shape circle" draggable="true" @dragstart="startDrag('circle', $event)"></div>
        <div class="shape square" draggable="true" @dragstart="startDrag('square', $event)"></div>
        <div class="shape horizontal-rectangle" draggable="true" @dragstart="startDrag('horizontal-rectangle', $event)"></div>
        <div class="shape vertical-rectangle" draggable="true" @dragstart="startDrag('vertical-rectangle', $event)"></div>
      </div>

      <!-- Stage Label -->
      <div class="stage">Stage</div>

      <!-- Canvas for Dropping Tables -->
      <div
        class="canvas"
        @dragover.prevent
        @drop="dropTable"
      >
        <div
          v-for="table in tables"
          :key="table.id"
          :class="['table', table.shape]"
          :style="{ top: table.position.y + 'px', left: table.position.x + 'px' }"
          @mousedown="startDragTable(table, $event)"
        >
          {{ table.number }}
        </div>
      </div>
    </main>
  </div>
</template>

<script>
export default {
  data() {
    return {
      tables: [],
      nextTableNumber: 1,
      draggedShape: null,
      draggingTable: null,
      dragOffset: { x: 0, y: 0 },
      isDraggingFromToolbar: false,
    };
  },
  methods: {
    navigateTo(page) {
      this.$router.push({ name: page });
    },
    logout() {
      this.$router.push({ name: "Login" });
    },
    startDrag(shape, event) {
      this.draggedShape = shape;
      this.dragOffset.x = event.offsetX;
      this.dragOffset.y = event.offsetY;
      this.isDraggingFromToolbar = true;
    },
    dropTable(event) {
      if (this.draggedShape) {
        const canvasRect = event.currentTarget.getBoundingClientRect();
        const x = event.clientX - canvasRect.left - this.dragOffset.x;
        const y = event.clientY - canvasRect.top - this.dragOffset.y;

        this.tables.push({
          id: Date.now(),
          shape: this.draggedShape,
          number: this.nextTableNumber,
          position: { x, y },
        });
        this.nextTableNumber += 1;
        this.draggedShape = null;
        this.isDraggingFromToolbar = false;
      }
    },
    startDragTable(table, event) {
      this.draggingTable = table;
      const tableRect = event.target.getBoundingClientRect();
      this.dragOffset.x = event.clientX - tableRect.left;
      this.dragOffset.y = event.clientY - tableRect.top;
      document.addEventListener("mousemove", this.onDragTable);
      document.addEventListener("mouseup", this.stopDragTable);
    },
    onDragTable(event) {
      if (this.draggingTable) {
        const canvas = this.$el.querySelector(".canvas");
        const canvasRect = canvas.getBoundingClientRect();

        let x = event.clientX - canvasRect.left - this.dragOffset.x;
        let y = event.clientY - canvasRect.top - this.dragOffset.y;

        // Move the table within canvas bounds, but allow it to go outside
        this.draggingTable.position = { x, y };
      }
    },
    stopDragTable(event) {
      if (!this.draggingTable) return;

      const canvas = this.$el.querySelector(".canvas");
      const canvasRect = canvas.getBoundingClientRect();

      // Check if the table was dropped outside the canvas
      const isOutside =
        event.clientX < canvasRect.left ||
        event.clientX > canvasRect.right ||
        event.clientY < canvasRect.top ||
        event.clientY > canvasRect.bottom;

      if (isOutside) {
        // Remove the table if it is dropped outside the canvas
        this.tables = this.tables.filter((table) => table.id !== this.draggingTable.id);
      }

      // Reset dragging state and remove listeners
      this.draggingTable = null;
      document.removeEventListener("mousemove", this.onDragTable);
      document.removeEventListener("mouseup", this.stopDragTable);
    },
  },
};
</script>

<style scoped>
.tables-screen {
  display: flex;
  /*background-color: #001643;*/
  color: white;
  height: 100vh;
}
/*
.main-content {
  flex: 1;
  padding: 2rem;
  display: flex;
  flex-direction: column;
  align-items: center;
  position: relative;
}
*/
.toolbar {
  position: absolute;
  top: 20px;
  right: 20px;
  display: flex;
  flex-direction: column;
  gap: 10px;
  z-index: 1;
}

/* Styles for each shape in the toolbar */
.shape {
  width: 40px;
  height: 40px;
  border: 2px solid #ff6b35;
  background-color: white;
  cursor: grab;
}

.circle {
  border-radius: 50%;
}

.square {
  /* Default square shape */
}

.horizontal-rectangle {
  width: 60px;
  height: 30px;
}

.vertical-rectangle {
  width: 30px;
  height: 60px;
}

.stage {
  position: absolute;
  top: 90px;
  left: 50%;
  transform: translateX(-50%);
  background-color: #ff6b35;
  color: white;
  padding: 5px 50px; /* Five times wider */
  border-radius: 5px;
}

.canvas {
  position: relative;
  margin-top: 40px;
  margin-bottom: 40px; /* Small margin at the bottom */
  margin-left: 20px;
  padding: 20px;
  border: 2px dashed #00cfff;
  min-height: calc(100vh - 210px); /* Adjust height to leave margin */
  width: calc(100% - 300px);
/*  background-color: #001643;*/
}

.table {
  position: absolute;
  display: flex;
  align-items: center;
  justify-content: center;
  color: #ff6b35;
  border: 2px solid #ff6b35;
  font-weight: bold;
  cursor: grab;
}

.table.circle {
  width: 40px;
  height: 40px;
  border-radius: 50%;
  background-color: white;
}

.table.square {
  width: 40px;
  height: 40px;
  background-color: white;
}

.table.horizontal-rectangle {
  width: 60px;
  height: 30px;
  background-color: white;
}

.table.vertical-rectangle {
  width: 30px;
  height: 60px;
  background-color: white;
}
</style>
